module.exports = __webpack_public_path__ + "img/bg.24d47568.png";